var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.winxin && _vm.androidFlag ? _c('div', {
    on: {
      "click": _vm.jumpApp
    }
  }, [_c('wx-open-launch-app', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "background": "transparent",
      "position": "absolute",
      "bottom": "0",
      "left": "0",
      "z-index": "10"
    },
    attrs: {
      "id": "launch-btn",
      "appid": "wx9a08a4f59ce91bf6",
      "extinfo": _vm.appLink
    }
  }, [_c('script', {
    attrs: {
      "type": "text/wxtag-template"
    }
  }, [_vm._v(" <style> .btn { background: transparent; } </style> <div class=\"btn\" style=\"width: 100%; height: 100%; position: absolute; bottom: 0px; left: 0px;\"> </div> ")])])], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };